export const CONFIRM_BUTTON_ROLES = ['primary', 'cancel', 'destructive'];
const NAMED_ENTITIES = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
  ndash: '–',
  mdash: '—',
  hellip: '…',
  lsquo: '‘',
  rsquo: '’',
  ldquo: '“',
  rdquo: '”',
  bull: '•',
  middot: '·',
  copy: '©',
  reg: '®',
  trade: '™',
  deg: '°',
  times: '×'
};
const PARAGRAPH_TAGS = new Set(['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'table']);
const LINE_TAGS = new Set(['div', 'tr', 'section', 'header', 'footer', 'article', 'dt', 'dd', 'thead', 'tbody']);
const CELL_TAGS = new Set(['td', 'th']);
const LIST_TAGS = new Set(['ul', 'ol']);
const TAG_PATTERN = /<(\/?)([a-zA-Z][\w-]*)((?:[^>"']|"[^"]*"|'[^']*')*)>/g;
export function decodeHtmlEntities(text) {
  return text.replace(/&(#x[0-9a-fA-F]+|#[0-9]+|[a-zA-Z]+);/g, (whole, ref) => {
    if (ref[0] === '#') {
      const code = ref[1] === 'x' || ref[1] === 'X' ? parseInt(ref.slice(2), 16) : parseInt(ref.slice(1), 10);
      if (!Number.isFinite(code) || code < 0 || code > 0x10ffff) return whole;
      return code === 0xa0 ? ' ' : String.fromCodePoint(code);
    }
    const named = NAMED_ENTITIES[(ref.toLowerCase())];
    return named === undefined ? whole : named;
  });
}
export function htmlToPlainText(html) {
  if (typeof html !== 'string' || html.length === 0) return '';
  const source = html.replace(/<!--[\s\S]*?(?:-->|$)/g, '').replace(/<(script|style|template|noscript)\b[\s\S]*?(?:<\/\1\s*>|$)/gi, '');
  let out = '';
  let listDepth = 0;
  const trimTrailingSpaces = () => {
    out = out.replace(/[ \t]+$/, '');
  };
  const ensureBreaks = (count) => {
    trimTrailingSpaces();
    if (out.length === 0) return;
    const existing = /\n*$/.exec(out)?.[0].length ?? 0;
    if (existing < count) out += '\n'.repeat(count - existing);
  };
  const appendText = (raw) => {
    let text = decodeHtmlEntities(raw.replace(/\s+/g, ' ')).replace(/[ \t ]+/g, ' ');
    if (out.length === 0 || /[\n ]$/.test(out)) text = text.replace(/^ +/, '');
    out += text;
  };
  let last = 0;
  TAG_PATTERN.lastIndex = 0;
  for (let match = TAG_PATTERN.exec(source); match !== null; match = TAG_PATTERN.exec(source)) {
    appendText(source.slice(last, match.index));
    last = TAG_PATTERN.lastIndex;
    const closing = match[1] === '/';
    const tag = match[2].toLowerCase();
    if (tag === 'br') {
      trimTrailingSpaces();
      out += '\n';
    } else if (PARAGRAPH_TAGS.has(tag)) {
      ensureBreaks(listDepth > 0 ? 1 : 2);
    } else if (LINE_TAGS.has(tag)) {
      ensureBreaks(1);
    } else if (LIST_TAGS.has(tag)) {
      listDepth = closing ? Math.max(0, listDepth - 1) : listDepth + 1;
      ensureBreaks(listDepth === 0 && closing ? 2 : 1);
    } else if (tag === 'li') {
      ensureBreaks(1);
      if (!closing) out += '  '.repeat(Math.max(0, listDepth - 1)) + '• ';
    } else if (CELL_TAGS.has(tag) && !closing) {
      if (out.length > 0 && !/[\n ]$/.test(out)) out += ' ';
    }
  }
  appendText(source.slice(last).replace(/<[^>]*$/, ''));
  return out.split('\n').map(line => line.replace(/\s+$/, '')).join('\n').replace(/\n{3,}/g, '\n\n').replace(/^\n+|\n+$/g, '');
}
export function roleFromClasses(classes) {
  const list = typeof classes === 'string' ? classes.split(/\s+/) : [];
  if (list.includes('btn-danger')) return 'destructive';
  if (list.includes('btn-default') || list.includes('btn-secondary')) return 'cancel';
  return 'primary';
}
export function isConfirmButtonRole(role) {
  return typeof role === 'string' && CONFIRM_BUTTON_ROLES.includes(role);
}